import React, { useState, useCallback, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import Home from './pages/Home';
import LegalPage from './pages/LegalPage';
import GoogleAnalyticsTracker from './components/GoogleAnalyticsTracker';
import ScrollToTop from './components/ScrollToTop';

const styles = {
  app: { minHeight: '100vh', background: 'transparent', paddingBottom: '48px' },
  container: {
    maxWidth: '1100px',
    margin: '0 auto',
    padding: '0 24px 36px',
    position: 'relative',
    zIndex: 1,
  },
};

export default function App() {
  const [theme, setTheme] = useState(() => {
    const storedTheme = window.localStorage.getItem('convertalldocs-theme');
    if (storedTheme === 'dark' || storedTheme === 'light') {
      return storedTheme;
    }
    return 'light';
  });

  useEffect(() => {
    document.body.classList.toggle('theme-dark', theme === 'dark');
    document.body.classList.toggle('theme-light', theme === 'light');
    window.localStorage.setItem('convertalldocs-theme', theme);
  }, [theme]);

  const handleToggleTheme = useCallback(() => {
    setTheme((currentTheme) => (currentTheme === 'dark' ? 'light' : 'dark'));
  }, []);

  return (
    <div style={styles.app}>
      <GoogleAnalyticsTracker />
      <div style={styles.container}>
        <Header theme={theme} onToggleTheme={handleToggleTheme} />

        <Routes>
          <Route path="/about" element={<LegalPage type="about" />} />
          <Route path="/contact" element={<LegalPage type="contact" />} />
          <Route path="/terms" element={<LegalPage type="terms" />} />
          <Route path="/privacy" element={<LegalPage type="privacy" />} />
          <Route path="/:slug?" element={<Home />} />
        </Routes>

        <Footer />
      </div>

      <CookieBanner />
      <ScrollToTop />
    </div>
  );
}
